/*
 * Mobiel menu (Figma "Two Sisters - Mobile - Navigation", node 780-4835).
 * Hoort bij snippets/header-mobile-menu.liquid; styling in header-mega-sidebar.css.
 *
 * - Neemt de hamburger van het thema over (#header-inner > .link-btn > a:first-child)
 *   zodat de standaard menu-drawer niet opent.
 * - Het menu opent direct onder de gewone header (logo en iconen blijven exact staan);
 *   de hamburger wordt een kruisje en sluit het menu weer.
 * - Openen/sluiten: fade + 20px van boven, zelfde timing als de winkelwagen-drawer.
 * - Accordeon: een rij klapt in de lijst zelf open; per niveau staat er één open.
 *   Productkaarten worden bij het openen geladen via
 *   /collections/<handle>?section_id=mega-menu-products.
 */
(function () {
  'use strict';

  var drawer = document.getElementById('ms-mnav');
  if (!drawer) return;

  var html = document.documentElement;
  var MOBILE_QUERY = window.matchMedia('(max-width: 1000px)');
  var DURATION = 400;
  var SUB_DURATION = 300;
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var lastTrigger = null;
  var closeTimer = null;

  function getBurger() {
    return document.querySelector('#header-inner > .link-btn > a:first-child');
  }

  // ---- Accordeon ---------------------------------------------------------------
  // Het open- en dichtklappen gebeurt volledig in CSS (grid-rijen). JS zet alleen
  // aria-expanded om, dus er zijn geen hoogtes of timers die uit de pas kunnen lopen.
  function subOf(toggle) {
    return document.getElementById(toggle.getAttribute('aria-controls'));
  }

  function isOpenToggle(toggle) {
    return toggle.getAttribute('aria-expanded') === 'true';
  }

  function collapse(toggle) {
    if (!isOpenToggle(toggle)) return;
    toggle.setAttribute('aria-expanded', 'false');
    var sub = subOf(toggle);
    if (!sub) return;
    // Wat eronder openstaat ook sluiten, zodat het bij opnieuw openen klein begint
    Array.prototype.forEach.call(sub.querySelectorAll('[data-ms-mnav-toggle]'), collapse);
  }

  function expand(toggle) {
    var sub = subOf(toggle);
    if (!sub) return;
    // Per niveau blijft er één open
    var list = toggle.closest('ul');
    if (list) {
      Array.prototype.forEach.call(list.querySelectorAll(':scope > li > [data-ms-mnav-toggle]'), function (other) {
        if (other !== toggle) collapse(other);
      });
    }
    toggle.setAttribute('aria-expanded', 'true');
    loadProducts(sub);
    setTimeout(function () { scrollIntoView(toggle); }, SUB_DURATION);
  }

  // Geopende rij in beeld houden als het menu onderaan uitklapt
  function scrollIntoView(toggle) {
    var body = drawer.querySelector('.ms-mnav-body');
    var rowTop = toggle.getBoundingClientRect().top - body.getBoundingClientRect().top + body.scrollTop;
    if (rowTop < body.scrollTop) {
      body.scrollTo({ top: rowTop, behavior: reduceMotion.matches ? 'auto' : 'smooth' });
    }
  }

  function toggleSub(toggle) {
    if (isOpenToggle(toggle)) collapse(toggle); else expand(toggle);
  }

  function closeAll() {
    Array.prototype.forEach.call(drawer.querySelectorAll('[data-ms-mnav-toggle]'), collapse);
  }

  // ---- Productkaarten ------------------------------------------------------------
  // De rij onder een groep is een mix van de collecties eronder: van elke collectie
  // worden de kaarten om en om gepakt, zodat alles vertegenwoordigd is.
  var cardCache = {};
  var CARDS = 8;

  function fetchCards(handle) {
    if (cardCache[handle]) return cardCache[handle];
    var url = root + 'collections/' + encodeURIComponent(handle) + '?section_id=mega-menu-products';
    cardCache[handle] = fetch(url)
      .then(function (response) { return response.ok ? response.text() : ''; })
      .then(function (text) {
        var doc = new DOMParser().parseFromString(text, 'text/html');
        return Array.prototype.slice.call(doc.querySelectorAll('.ms-card'));
      })
      .catch(function () { return []; });
    return cardCache[handle];
  }

  function loadProducts(sub) {
    var container = sub.querySelector(':scope > .ms-mnav-sub-inner > [data-ms-mnav-products]');
    if (!container || container.dataset.msLoaded) return;
    container.dataset.msLoaded = 'true';
    var handles = (container.dataset.msMnavProducts || '').split(',').filter(Boolean);
    if (!handles.length) return;
    Promise.all(handles.map(fetchCards)).then(function (lists) {
      var list = document.createElement('ul');
      list.className = 'ms-cards';
      var index = 0;
      var seen = {};
      while (list.children.length < CARDS) {
        var added = false;
        for (var i = 0; i < lists.length && list.children.length < CARDS; i++) {
          var card = lists[i][index];
          if (!card) continue;
          added = true;
          var link = card.querySelector('a[href]');
          var key = link ? link.getAttribute('href') : Math.random();
          if (seen[key]) continue; // zelfde product in twee collecties
          seen[key] = true;
          list.appendChild(card);
        }
        if (!added) break; // alle collecties zijn op
        index++;
      }
      var skeleton = container.querySelector('.ms-cards-skeleton');
      if (!list.children.length) {
        // Geen producten: ook geen placeholder laten staan
        if (skeleton) skeleton.parentNode.removeChild(skeleton);
        return;
      }
      if (skeleton) skeleton.parentNode.replaceChild(list, skeleton);
      else container.appendChild(list);
    });
  }

  // ---- Openen en sluiten ---------------------------------------------------------
  // Onderrand van de header = bovenkant van het menu
  function headerEl() {
    return document.getElementById('header') || document.querySelector('.shopify-section-header');
  }

  function setTop() {
    var header = headerEl();
    if (!header) return;
    // Exact op de onderrand van de header (geen afronding, geen overlap): de header-lijn blijft
    // altijd precies één keer zichtbaar en dient als bovenrand van het menu
    var bottom = Math.max(0, header.getBoundingClientRect().bottom);
    drawer.style.setProperty('--ms-mnav-top', bottom + 'px');
  }

  // De header kan na het openen nog van hoogte veranderen (logo, lettertypes, aankondigingsbalk).
  // Daarom blijven we de bovenkant bijhouden zolang het menu open is, anders schuift het menu
  // over de header heen en valt de eerste rij erachter.
  function watchHeader() {
    var header = headerEl();
    if (!header || !window.ResizeObserver) return;
    new ResizeObserver(function () {
      if (html.classList.contains('ms-mnav-open')) setTop();
    }).observe(header);
  }
  watchHeader();
  window.addEventListener('load', function () {
    if (html.classList.contains('ms-mnav-open')) setTop();
  });
  window.addEventListener('scroll', function () {
    if (html.classList.contains('ms-mnav-open')) setTop();
  }, { passive: true });

  function open(trigger) {
    clearTimeout(closeTimer);
    lastTrigger = trigger || null;
    setTop();
    // Nog een keer meten zodra de pagina is uitgerenderd
    requestAnimationFrame(setTop);
    setTimeout(setTop, 300);
    setTimeout(setTop, 1000);
    drawer.removeAttribute('inert');
    drawer.setAttribute('aria-hidden', 'false');
    html.classList.add('ms-mnav-open');
    document.dispatchEvent(new CustomEvent('ms:menu-open'));
    var burger = getBurger();
    if (burger) burger.setAttribute('aria-expanded', 'true');
    var first = drawer.querySelector('.ms-mnav-row');
    if (first) setTimeout(function () { first.focus({ preventScroll: true }); }, 50);
  }

  function close(returnFocus) {
    if (!html.classList.contains('ms-mnav-open')) return;
    html.classList.remove('ms-mnav-open');
    drawer.setAttribute('aria-hidden', 'true');
    drawer.setAttribute('inert', '');
    var burger = getBurger();
    if (burger) burger.setAttribute('aria-expanded', 'false');
    closeTimer = setTimeout(function () {
      closeAll();
      closeLocaleLists();
      drawer.querySelector('.ms-mnav-body').scrollTop = 0;
    }, DURATION);
    if (returnFocus !== false && lastTrigger) lastTrigger.focus({ preventScroll: true });
  }

  // Hamburger van het thema overnemen (capture: vóór de thema-listener op het element)
  function isBurgerEvent(event) {
    if (!MOBILE_QUERY.matches) return null;
    var burger = getBurger();
    if (!burger) return null;
    return event.target.closest && event.target.closest('#header-inner > .link-btn > a:first-child') === burger ? burger : null;
  }
  function toggle(burger) {
    if (html.classList.contains('ms-mnav-open')) close(); else open(burger);
  }
  document.addEventListener('click', function (event) {
    var burger = isBurgerEvent(event);
    if (!burger) {
      // Ander icoon in de header (zoeken, account, hart, winkelwagen) terwijl het menu open is:
      // menu sluiten en de klik gewoon laten doorgaan
      if (html.classList.contains('ms-mnav-open') && event.target.closest && event.target.closest('#header-inner')) {
        close(false);
      }
      return;
    }
    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();
    toggle(burger);
  }, true);
  document.addEventListener('keyup', function (event) {
    if (event.key !== ' ') return;
    var burger = isBurgerEvent(event);
    if (!burger) return;
    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();
    toggle(burger);
  }, true);
  window.addEventListener('resize', function () {
    if (html.classList.contains('ms-mnav-open')) setTop();
  });
  var burger = getBurger();
  if (burger) {
    burger.setAttribute('aria-controls', 'ms-mnav');
    burger.setAttribute('aria-expanded', 'false');
  }

  // Klikken binnen de drawer
  drawer.addEventListener('click', function (event) {
    var t = event.target;
    var el;

    if ((el = t.closest('[data-ms-mnav-close]'))) {
      event.preventDefault();
      close();
      return;
    }
    if ((el = t.closest('[data-ms-mnav-toggle]'))) {
      event.preventDefault();
      toggleSub(el);
      return;
    }
    if ((el = t.closest('[data-ms-mnav-cart]'))) {
      var cartLink = document.querySelector('#nav-user li.cart > a[data-panel="cart"]');
      if (!cartLink) return; // gewoon naar /cart
      event.preventDefault();
      close(false);
      setTimeout(function () { cartLink.click(); }, 50);
      return;
    }
    if (t.closest('[data-ms-mnav-wishlist]')) {
      // Swym opent de verlanglijst via .swym-wishlist; menu sluiten zodat de popup zichtbaar is
      close(false);
      return;
    }
  });

  // Land/taal: zelfde weergave als desktop ("EUR (€)" + vlag), tik opent de lijst
  function closeLocaleLists(except) {
    Array.prototype.forEach.call(drawer.querySelectorAll('[data-ms-mnav-locale-toggle]'), function (btn) {
      var list = document.getElementById(btn.dataset.msMnavLocaleToggle);
      if (!list || list === except) return;
      list.hidden = true;
      btn.setAttribute('aria-expanded', 'false');
    });
  }
  drawer.addEventListener('click', function (event) {
    var toggleBtn = event.target.closest('[data-ms-mnav-locale-toggle]');
    if (toggleBtn) {
      event.preventDefault();
      var list = document.getElementById(toggleBtn.dataset.msMnavLocaleToggle);
      if (!list) return;
      closeLocaleLists(list);
      list.hidden = !list.hidden;
      toggleBtn.setAttribute('aria-expanded', list.hidden ? 'false' : 'true');
      return;
    }
    var option = event.target.closest('[data-ms-mnav-locale-set]');
    if (option) {
      event.preventDefault();
      var form = option.closest('form');
      var input = form && form.querySelector('input[name="' + option.dataset.msMnavLocaleSet + '"]');
      if (!input) return;
      if (input.value === option.value) { closeLocaleLists(); return; }
      input.value = option.value;
      form.submit();
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && html.classList.contains('ms-mnav-open')) close();
  });
  // Zoek-dropdown opent: menu sluiten
  document.addEventListener('ms:search-open', function () { close(false); });

  // Naar desktopformaat: menu sluiten
  var onQueryChange = function (e) { if (!e.matches) close(false); };
  if (MOBILE_QUERY.addEventListener) MOBILE_QUERY.addEventListener('change', onQueryChange);
  else if (MOBILE_QUERY.addListener) MOBILE_QUERY.addListener(onQueryChange);
})();
